<template>
  <ExternalQueryList
      headline="Ads"
      endpoint="/api/v1/ads"
      :endpoint-filters="{project_id: project.id}"
      :default-page-size="0"
      :page-size-options="null"
      :headlines="headlines"
      :checkbox-column-width="2"
      :button-column-width="2"
      :can-show="() => true"
      :can-destroy="() => false"
      @show="ad => $router.push(getUrl(ad))"
  >
    <template v-slot:default="{ row: ad }">
      <td class="table__ellipsis">
        <router-link :to="getUrl(ad)">
          {{ ad.order.company.name }}
        </router-link>
      </td>

      <td>
        <AdDetailIcons :ad="ad"/>
      </td>

      <td class="table__ellipsis">
        <router-link :to="'/users/' + ad.order.user.id">
         {{ ad.order.user.full_name }}
        </router-link>
      </td>

      <td>
        <AdCostIcons :ad="ad"/>
      </td>

      <td class="table__ellipsis">
        {{ ad.price | price }}
        <small>({{ ad.list_price | price }})</small>
      </td>
    </template>

    <template v-slot:foot="{ data: ads }">
      <tfoot v-if="ads.length">
      <tr>
        <td colspan="4" class="text-right">
          Subtotal
        </td>

        <td></td>

        <td colspan="2">
          {{ getSubTotalPrice(ads) | price }}
          <small>({{ getSubTotalListPrice(ads) | price }})</small>
        </td>
      </tr>

      <tr>
        <td colspan="4" class="text-right">
          Agency Commission
        </td>

        <td></td>

        <td colspan="2">
          {{ -getTotalAgencyCommission(ads) | price }}
        </td>
      </tr>

      <tr>
        <td colspan="4" class="text-right">
          Third Party Costs
        </td>

        <td></td>

        <td colspan="2">
          {{ -getTotalThirdPartyCosts(ads) | price }}
        </td>
      </tr>

      <tr>
        <td colspan="4" class="text-right">
          <b>
            Total
          </b>
        </td>

        <td></td>

        <td colspan="2">
          <b>
            {{ getTotalPrice(ads) | price }}
          </b>
        </td>
      </tr>
      </tfoot>
    </template>
  </ExternalQueryList>
</template>

<script>
import ExternalQueryList from '../../../Panels/Lists/ExternalQuery'
import AdDetailIcons from "../../../Icons/AdDetailIcons.vue";
import AdCostIcons from "../../../Icons/AdCostIcons.vue";

export default {
  components: {AdCostIcons, AdDetailIcons, ExternalQueryList},

  props: {
    project: {
      required: true
    }
  },

  data() {
    return {
      editing: null
    }
  },

  computed: {
    headlines() {
      return [
        {width: 6, text: 'Company'},
        {width: 2},
        {width: 6, text: 'User'},
        {width: 2},
        {width: 4, text: 'Price'},
      ]
    }
  },

  methods:{
    getSubTotalPrice(ads) {
      return ads.reduce((total, ad) => {
        return total + ad.price
      }, 0)
    },

    getSubTotalListPrice(ads) {
      return ads.reduce((total, ad) => {
        return total + ad.list_price
      }, 0)
    },

    getTotalAgencyCommission(ads) {
      return ads.reduce((total, ad) => {
        return total + ad.agency_commission
      }, 0)
    },

    getTotalThirdPartyCosts(ads) {
      return ads.reduce((total, ad) => {
        return total + ad.third_party_costs
      }, 0)
    },

    getTotalPrice(ads) {
      return this.getSubTotalPrice(ads) - this.getTotalAgencyCommission(ads) - this.getTotalThirdPartyCosts(ads)
    },

    getUrl(ad) {
      return '/companies/'+ ad.order.company.id + '/orders/' + ad.order.id
    }
  },
}
</script>
